import i18n from 'i18next';
import { registerValidator } from 'core/forms';

const isRequired = ({ fieldValue }) => ({
  error: i18n.t('error-required-field-error'),
  hasError: !fieldValue,
  isRequired: true,
});

registerValidator('isRequired', isRequired);

export default isRequired;
